import React from 'react';
import { Field, isDirty, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import MenuTitle from 'components/MenuTitle';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import {
  onClickOpenActivityLogModal,
  onClickAddBankV2,
  onChangeSearchBankAccounts,
} from 'actions/setting/bankAccount';
import { askConfirmAction } from 'actions/confirm-action';
import styles from './style.css';

class ActionBar extends React.Component {
  render() {
    return (
      <div>
        <div className="row ml-0px">
          <MenuTitle menuTitle="Bank Account" />
        </div>

        <div className="row pb-20px">
          <div className="col-md-4 col-xs-12">
            <form className="form-inline pt-0px">
              <div className="form-group mr-5px">
                <Field
                  component={SearchBar}
                  name="query"
                  onChange={this._onChangeSearchBankAccounts}
                  placeholder="Search"
                />
              </div>
            </form>
          </div>
          <div className="col-md-8 col-xs-12">
            <span className="pull-right">
              <button
                className={`btn mr-10px ${styles['btn-outline-primary']} ${
                  styles['btn-large']
                }`}
                onClick={this._onClickActivityLog}
              >
                Activity Log
              </button>
              <button
                className={`btn btn-primary ${styles['btn-large']}`}
                onClick={this._onClickAddBankAccount}
              >
                Add Bank
              </button>
            </span>
          </div>
        </div>
      </div>
    );
  }

  _onClickActivityLog = () => {
    this.props.dispatch(onClickOpenActivityLogModal());
  };

  _onClickAddBankAccount = () => {
    if (this.props.isDirtyBankAccountForm) {
      this.props.dispatch(askConfirmAction(onClickAddBankV2()));
    } else {
      this.props.dispatch(onClickAddBankV2());
    }
  };

  _onChangeSearchBankAccounts = (e, query) => {
    const { bankAccounts, banks, outlets } = this.props;

    this.props.dispatch(
      onChangeSearchBankAccounts(query, bankAccounts, banks, outlets)
    );
  };
}

const mapForm = {
  form: 'searchForm',
};

function mapStateToProps(state) {
  const { bankAccountLists, bankList, outlets } = state.setting.bankAccount;

  return {
    bankAccounts: bankAccountLists,
    banks: bankList,
    outlets,
    isDirtyBankAccountForm: isDirty('bankAccountForm')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ActionBar)
);
